/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { IconPaths, KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { useAuth } from '../auth'

export const AccountHeader: React.FC = () => {
  const location = useLocation()

  const { currentUser } = useAuth()

  const imageDefault = '/media/avatars/blank.png'
  const imagePerfil = toAbsoluteUrl(String(currentUser?.imagemPerfil))
  const hasImage = currentUser?.imagemPerfil !== null

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              <img src={hasImage ? imagePerfil : imageDefault} alt='Imagem do Perfil' />
              <div className='position-absolute translate-middle bottom-0 start-100 mb-6'></div>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 fs-2 fw-bolder me-1'>
                    {currentUser?.pessoa?.nome}
                  </span>
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 text-gray-400  mb-2'>
                  <div className='d-flex justify-content-center align-items-center me-5'>
                    <KTSVG path={IconPaths.Profile} className='svg-icon-4 me-1' />
                    <span>{currentUser?.grupo?.descricao}</span>
                  </div>
                  <div className='d-flex justify-content-center align-items-center'>
                    <KTSVG path={IconPaths.Email} className='svg-icon-4 me-1' />
                    <span>{currentUser?.email}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/crafted/account/overview' && 'active')
                }
                to='/crafted/account/overview'
              >
                Meu Perfil
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/crafted/account/settings' && 'active')
                }
                to='/crafted/account/settings'
              >
                Alterar Perfil
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
